import { Component } from '@angular/core';

@Component({
  selector: 'app-blockquotes-demo',
  templateUrl: './blockquotes-demo.component.html',
})
export class BlockquotesDemoComponent {}
